export default () => jQuery(($) => {
	if ($('#campus-calendar-outer-wrapper')) {
		var calendarWrapperData = $('#campus-calendar-outer-wrapper');
		var carleton_calendar_toggleFilters = calendarWrapperData.data('toggleFilters');
		var carleton_calendar_showPastDates = calendarWrapperData.data('showPastDates');
		var carleton_calendar_duetDatePickerDefault = calendarWrapperData.data('duetDatePickerDefault');
		var carleton_calendar_duetDatePickerJump = calendarWrapperData.data('jumpToDate');

		$('#campus_calendar_filters').submit(function () {
			var searchField = $('.campus-calendar--legend input[name="calendar_search"]');
			if (searchField.val()) {
				$('.campus-calendar--legend select[name="date_select"]').prop('disabled', true);
				$('.campus-calendar--legend input[name="filter_view"]').prop('disabled', true);
				$('.campus-calendar--legend input[name="filter_date"]').prop('disabled', true);
			} else {
				searchField.prop('disabled', true);
			}
			$('.campus-calendar--legend input[name="jump_to_date"]').prop('disabled', true);

			return true;
		});
		$('.campus-calendar--legend select#date_select').change(function () {
			$('.campus-calendar--legend input[name="filter_view"]').prop('disabled', true);
			$('.campus-calendar--legend input[name="filter_date"]').prop('disabled', true);
			$('#campus_calendar_filters').submit();
		});
		$('.campus-calendar--legend input[type="checkbox"]').click(function () {
			$('.campus-calendar--legend select[name="date_select"]').prop('disabled', true);
			$('.campus-calendar--legend input[name="filter_view"]').prop('name', 'view');
			$('.campus-calendar--legend input[name="filter_date"]').prop('name', 'start_date');
			$('#campus_calendar_filters').submit();
		});
		$('#event_filters_toggle').click(function () {
			$('#event_filters_toggle .opened, #event_filters_toggle .closed, #event_filters').toggle();
		});
		if (carleton_calendar_toggleFilters) {
			$('#event_filters_toggle .opened, #event_filters_toggle .closed, #event_filters').toggle();
		}
		$('.remove-event-filter').click(function () {
			var type = $(this).attr('data-type');
			$('.campus-calendar--legend select[name="date_select"]').prop('disabled', true);
			$('.campus-calendar--legend input[name="filter_view"]').prop('disabled', true);
			$('.campus-calendar--legend input[name="filter_date"]').prop('disabled', true);
			$('.campus-calendar--legend input[type="checkbox"][name^="' + type + '"]').prop("checked", false);
			$(this).hide();
			$('#campus_calendar_filters').submit();
		});

		$('.calendar__past-events__show').click(function () {
			$(this).hide();
			$('.calendar__past-events__hide').show();
			$('.past_date').addClass('past_date_show');
		});
		$('.calendar__past-events__hide').click(function () {
			$(this).hide();
			$('.calendar__past-events__show').show();
			$('.past_date').removeClass('past_date_show');
		});
		if (carleton_calendar_showPastDates) {
			$('.past_date').addClass('past_date_show');
		}

		if ($('.single_event_header')) {
			$('#calendar_admin_form--add_event').submit(function (event) {
				event.preventDefault();
				console.log('Adding event to another calendar...');

				var singleEventHeader = $('.single_event_header');
				var singleEventCalendarId = singleEventHeader.data('calendarId');
				var singleEventId = singleEventHeader.data('singleEventId');
				var singleEventajaxAddEvent = singleEventHeader.data('ajaxAddEvent');
				var selected_site_id = $('#add_event_to_calendar').val();
				if (selected_site_id) {
					$.get(
						singleEventajaxAddEvent + '&calendarId=' + singleEventCalendarId + '&eventId=' + singleEventId + '&targetSiteId=' + selected_site_id,
						function (data) {
							if (data && data.success) {
								alert(data.data.message);
							} else {
								alert('Could not add event');
							}
						});

					return false;
				}
			});
		}

		if (window.location.href.match('clear_calendar_search')) {
			history.replaceState({}, document.title, window.location.href.split('?')[0]);
		}

		// Select the date picker component
		const duetDatePicker = document.querySelector("duet-date-picker");
		const formatDateForCal = rawDate => {
			return rawDate ? rawDate.getFullYear() + '-' + ("0" + (rawDate.getMonth() + 1)).slice(-2) + '-' + ("0" + rawDate.getDate()).slice(-2) : null;
		}
		if (duetDatePicker) {
			// Listen for when date is selected
			duetDatePicker.addEventListener("duetChange", function (e) {
				console.log("selected date", e.detail, e.detail.valueAsDate, formatDateForCal(e.detail.valueAsDate));
				if (e.detail.valueAsDate) {
					window.location = carleton_calendar_duetDatePickerJump + 'start_date=' + formatDateForCal(e.detail.valueAsDate) + '&view=day';
				} else {
					duetDatePicker.value = carleton_calendar_duetDatePickerDefault;
				}

			});
		}
	}
});
